import {
  startPattern as assignTaskToPersonApi,
  getOperationPackageCountInProgress as getOperationPackageCountInProgressApi,
  getOperationPackageInstances as getOperationPackageInstancesApi,
  getOperationPackagePatterns as getOperationPackagePatternsApi,
  getOperationPackages as getOperationPackagesApi,
  getOperationTaskCountInProgress as getOperationTaskCountInProgressApi,
  type StartPatternResponse,
  type OperationPackageCountInProgressResponse,
  type OperationPackageInstancesResponse,
  type OperationPackagePatternsResponse,
  type OperationPackagesResponse,
  type OperationTaskCountInProgressResponse,
  type PostOperationPackagePatternsResponse,
} from "@/features/operation-packages/api";
import {
  useGetOperationPackageCountInProgress as useGetOperationPackageCountInProgressCommon,
  useGetOperationPackageInstances as useGetOperationPackageInstancesCommon,
  useGetOperationPackagePatterns as useGetOperationPackagePatternsCommon,
  useGetOperationPackages as useGetOperationPackagesCommon,
  useGetOperationTaskCountInProgress as useGetOperationTaskCountInProgressCommon,
  usePostOperationPackagePatterns as usePostOperationPackagePatternsCommon,
} from "@/features/operation-packages/hooks";

const OWNER_PRODUCT = "HRF_LABOR_CORE";

// --- API Wrappers (for usage outside hooks if needed) ---

export type GetOperationPackagesRes = OperationPackagesResponse;
export const getOperationPackages = () =>
  getOperationPackagesApi(OWNER_PRODUCT);

export type GetOperationPackageCountInProgressRes =
  OperationPackageCountInProgressResponse;
export const getOperationPackageCountInProgress = (id: string) =>
  getOperationPackageCountInProgressApi(OWNER_PRODUCT, id);

export type GetOperationPackagePatternsRes = OperationPackagePatternsResponse;
export const getOperationPackagePatterns = (id: string) =>
  getOperationPackagePatternsApi(OWNER_PRODUCT, id);

export type PostOperationPackagePatternsRes =
  PostOperationPackagePatternsResponse;

export type AssignTaskToPersonRes = StartPatternResponse;
export const assignTaskToPerson = (
  id: string,
  patternId: string,
  body: { targetPersonIds: string[]; anchorDate: string },
) => assignTaskToPersonApi(OWNER_PRODUCT, id, patternId, body);

export type GetOperationTaskCountInProgressRes =
  OperationTaskCountInProgressResponse;
export const getOperationTaskCountInProgress = (
  id: string,
  patternId: string,
) => getOperationTaskCountInProgressApi(OWNER_PRODUCT, id, patternId);

export type GetOperationPackageInstancesRes = OperationPackageInstancesResponse;
export const getOperationPackageInstances = ({
  patternId,
}: {
  patternId: string;
}) => getOperationPackageInstancesApi(OWNER_PRODUCT, patternId);

// --- Hooks Wrappers ---

export const useGetOperationPackages = () =>
  useGetOperationPackagesCommon(OWNER_PRODUCT);

export const useGetOperationPackageCountInProgress = (id: string) =>
  useGetOperationPackageCountInProgressCommon(OWNER_PRODUCT, id);

export const useGetOperationPackagePatterns = (
  id: string,
  options?: { enabled?: boolean },
) => useGetOperationPackagePatternsCommon(OWNER_PRODUCT, id, options);

export const usePostOperationPackagePatterns = (
  id: string,
  options?: { onSuccess?: () => void; onError?: (error: Error) => void },
) => usePostOperationPackagePatternsCommon(OWNER_PRODUCT, id, options);

export const useGetOperationTaskCountInProgress = (params: {
  operationPackageId: string;
  patternId: string;
}) =>
  useGetOperationTaskCountInProgressCommon({
    ownerProduct: OWNER_PRODUCT,
    ...params,
  });

export const useGetOperationPackageInstances = (
  patternId: string,
  options?: { enabled?: boolean },
) => useGetOperationPackageInstancesCommon(OWNER_PRODUCT, patternId, options);
